module.exports = __webpack_public_path__ + "static/img/hlxd.505fadf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hlxd.png
// module id = onPw
// module chunks = 1